export const createGetUserRequest = (disableLoading = false) => {
  return {
    url: '/users/me',
    method: 'GET',
    disableLoading,
  };
};

export const createGetInvoiceRequest = () => {
  return {
    url: '/users/invoices',
    method: 'GET',
  };
};

export const createGetUserAccountDetails = () => {
  return {
    url: '/users/account_details',
    method: 'GET'
  }
}

export const createPostLoginRequest = (redirectUrl = null, userType = null, attribution = null) => {
  const data = { redirect_url: redirectUrl };
  if (userType) {
    data.user_type = userType;
  }
  if (attribution) {
    data.attribution = attribution;
  }
  return {
    url: '/users/post_login_init',
    method: 'POST',
    data,
  };
};
